import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

// Services
import { LayoutService } from '../../services/layout.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { EntidadService } from '@entidad/services/entidad.service';

// Interfaces & Envs
import { LogoEntidad } from '@entidad/interfaces/entidad-logo.interface';
import { environment } from '@environments/environment';
import { Entidad } from '@entidad/interfaces';
import { CurrentSimpleUser } from '@auth/interfaces/current-simple-user.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidenavEmitter = new EventEmitter<boolean>();
  API_SERVER = environment.API_SERVER;

  opened: boolean = false;

  currentUser: CurrentSimpleUser | null = null;
  userDisplayName: string = '';
  userDisplayRole: string = '';

  vm$: Observable<{ entidad: Entidad | null; logoUrl: SafeUrl | null }> = combineLatest([
    this.entidadService.entidad$,
    this.entidadService.logos$,
  ]).pipe(
    map(([entidad, logos]) => ({
      entidad,
      logoUrl: this.computeLogoUrl(logos),
    })),
  );

  constructor(
    private readonly authService: AuthService,
    private readonly confirmationService: ConfirmationService,
    private readonly entidadService: EntidadService,
    private readonly layoutService: LayoutService,
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
      if (user) {
        this.userDisplayName = this.capitalize(user.sessionUser || 'Usuario');
        this.userDisplayRole = `Rol: ${user.nombreRol}`;
      }
    });

    this.layoutService.sidebarOpen$.subscribe((status) => {
      this.opened = status;
    });
  }

  toggleSidenav() {
    this.layoutService.toggleSidebar();
  }

  logout() {
    this.confirmationService.confirm({
      key: 'headerLogoutDialog',
      message: '¿Estás seguro que quieres cerrar tu sesión?',
      header: 'Confirmar Cierre',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.handleLogout(),
    });
  }

  private handleLogout() {
    this.authService.logOut();
    this.entidadService.clearDatosEntidad();
    this.layoutService.setSidebarState(false);
  }

  private computeLogoUrl(logos: LogoEntidad[]): SafeUrl | null {
    const logoSistema = logos.find((l) => l.posicion === 'logo_sistema');
    if (!logoSistema) return null;

    const url = `${this.API_SERVER}/uploads/${logoSistema.path}?t=${Date.now()}`;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  private capitalize(palabra: string): string {
    if (!palabra) return '';
    return palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase();
  }
}
